import React from 'react';
import Reflux from 'reflux';
import { Row, Col } from 'bootstrap';
import MessageConstants from 'shared/constants/Messages';

export default React.createClass({
  displayName: 'GlobalElementsActivation',

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  mixins: [Reflux.ListenerMixin],

  render() {
    return (
      <div className="ge-activation">
        <Row>
          <Col md={24} className="ge-activation-img">
            <img src="/static/img/components/globalElements/globalElementsHeroImage.png" />
          </Col>
          <Col md={24} className="ge-activation-title">
            <h2>Welcome to our new Global Elements!</h2>
          </Col>
          <Col md={24} className="ge-activation-desc">
            <p>{MessageConstants.upgradeGlobalElements}</p>
          </Col>
          <Col md={24} className="ge-activation-learn">
            <p>
              For more information and to request access,
              <a
                href="https://shoflo.tv/global-elements/"
                rel="noopener noreferrer"
                target="_blank"
              >
                {' '}
                click here
              </a>
              .
            </p>
          </Col>
        </Row>
      </div>
    );
  },
});
